import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1.5 text-xs">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-800" : "text-foreground-500"}>
                {item.label}
              </span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>}
          </span>
        );
      })}
    </nav>
  );
}